import type SVGType from 'types/svg.types';

const BankTab: SVGType = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="bank">
      <path
        id="Vector 839"
        d="M12 4.83853L19.25 8.46353V8.65H4.75V8.46353L12 4.83853Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        id="Vector 840"
        d="M6 10.5V17.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        id="Vector 844"
        d="M4 19.3H20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        id="Vector 841"
        d="M10 10.5V17.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        id="Vector 842"
        d="M14 10.5V17.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        id="Vector 843"
        d="M18 10.5V17.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default BankTab;
